/** @jsx h */
import { FunctionalComponent, h } from 'preact';
import { connect } from 'react-redux';
import FooterNavigation from '../../components/footer';
import { AppState } from '../../interfaces/appState';
import { IMainModel } from '../../models/Main';
import { IMenuLocationModel } from '../../models/MenuLocation';
import { modulesByKeySelector } from '../../selectors/modulesSelectors';
import { footerMenuLocationListSelector } from '../../selectors/topNavSelectors';

export interface IFooterProps {
  main: IMainModel;
  footerMenuLocationMap: {
    faqLocation: IMenuLocationModel;
    topLinksLocation?: IMenuLocationModel;
    bottomLinksLocation?: IMenuLocationModel;
    appLinksLocation?: IMenuLocationModel;
    socialLinksLocation?: IMenuLocationModel;
    contentBlockLocation?: IMenuLocationModel;
  };
}

const Footer: FunctionalComponent<IFooterProps> = ({ footerMenuLocationMap, main }) => (
  <FooterNavigation main={main} {...footerMenuLocationMap} />
);

const mapStateToProps = (state: AppState) => ({
  footerMenuLocationMap: footerMenuLocationListSelector(state),
  main: modulesByKeySelector(state, 'main'),
});

export default connect(mapStateToProps)(Footer);
